<template>
	<div style="width: 100%">
		<div :id="'jsoneditor-' + id"></div>
		<b-button @click="start">Test</b-button>
		<br /><br />
		<p v-if="typeof results == 'string'">{{ results }}</p>

		<b-tabs>
			<b-tab title="Résultat">
				<h3>
					Résultat
					<span v-if="typeof results == 'object' && results.results"
						>({{ results.results.length }})</span
					>
				</h3>
				<div v-for="(group, key) in results.results" v-bind:key="key">
					<b-card>
						<div v-for="(value, key2) in group" v-bind:key="key2">
							<span>{{ key2 }}</span>
							<b-card
								v-for="(item, key3) in value"
								v-bind:key="key3">
								<span v-html="item"></span>
							</b-card>
						</div>
					</b-card>
				</div>
				<div
					v-if="
						typeof results == 'object' &&
						results.page &&
						results.page.length > 0
					">
					<h3>Url page suivante</h3>
					<div>{{ results.page[0] }}</div>
				</div>
			</b-tab>
			<b-tab title="Métadonnées">
				<h3>Métadonnées</h3>
				<div v-if="typeof results == 'object' && results.meta">
					<div v-for="(group, key) in results.meta" v-bind:key="key">
						<b-button
							variant="link"
							@click="
								add_meta({
									name: group.name,
									column: group.name,
								})
							"
							><i class="fas fa-plus"></i></b-button
						><span>{{ key }} </span>
						<b>{{ group.name }}</b>
						<b-card>
							{{ group.content }}
						</b-card>
					</div>
				</div>
			</b-tab>
			<b-tab title="Balises">
				<h3>Balises</h3>
				<vue-tags-input
					:placeholder="'ajouter balises'"
					style="max-width: 100%"
					v-model="balise"
					:tags="tags_balises"
					@tags-changed="(newTags) => (tags_balises = newTags)"
					:allow-edit-tags="true" />
				<br />
				<div v-if="typeof results == 'object' && results.balises">
					<div
						v-for="(group, key) in results.balises"
						v-bind:key="key">
						<b-card>
							<div
								v-for="(value, key2) in group"
								v-bind:key="key2">
								<b-button
									variant="link"
									@click="
										add_balise({
											name: key2,
											column: key2,
											index: '',
											separator: ' | ',
										})
									"
									><i class="fas fa-plus"></i></b-button
								><span>{{ key2 }}</span>
								<b-card
									v-for="(item, key3) in value"
									v-bind:key="key3">
									<b-container
										style="
											margin: 0px !important;
											padding: 0px !important;
										">
										<b-row
											style="
												margin: 0px !important;
												padding: 0px !important;
											">
											<b-col
												cols="auto"
												style="
													margin: 0px !important;
													padding: 0px !important;
												">
												<b-button
													variant="link"
													@click="
														add_balise({
															name: key2,
															column:
																key2 +
																' - ' +
																(key3 + 1),
															index: key3 + 1,
															separator: '',
														})
													"
													><i class="fas fa-plus"></i
												></b-button>
											</b-col>
											<b-col
												cols="auto"
												style="
													margin: 0px !important;
													padding: 0px !important;
												">
												<span v-html="item"></span>
											</b-col>
										</b-row>
									</b-container>
								</b-card>
							</div>
						</b-card>
					</div>
				</div>
			</b-tab>
			<b-tab title="Paramètres xpath">
				<h3>Paramètres</h3>
				<pre>{{ results.params }}</pre>
			</b-tab>
			<b-tab title="Résultats bruts">
				<h3>Résultats bruts</h3>
				<pre>{{ results.results_string }}</pre>
				<div v-if="typeof results == 'object' && results.meta_string">
					<h3>Métadonnées</h3>
					<pre>{{ results.meta_string }}</pre>
				</div>
				<div
					v-if="typeof results == 'object' && results.balises_string">
					<h3>Balises</h3>
					<pre>{{ results.balises_string }}</pre>
				</div>
			</b-tab>
			<b-tab title="Résultats xpath">
				<h3>Résultats xpath</h3>
				<pre>{{ results.details }}</pre>
			</b-tab>
			<b-tab title="Mapping">
				<div :id="'jsoneditor-mapping-' + id"></div>
				<edit_tabulator
					:extern_file="false"
					ref="edit_tabulator"></edit_tabulator>
			</b-tab>
			<b-tab title="Template">
				<p>Nom du template</p>
				<b-input v-model="name_template"></b-input>
				<br />
				<b-button @click="save_template">Sauvergarder</b-button>
			</b-tab>
			<b-tab v-if="screenshot" title="screenshot">
				<p>Screenshot</p>
				<img :src="'data:image/jpg;base64,' + screenshot" />
			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";
	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	import uniqueId from "lodash.uniqueid";
	import VueTagsInput from "@johmun/vue-tags-input";
	import { JSONEditor } from "@json-editor/json-editor";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	var clone = require("clone");
	const _ = require("underscore");

	import edit_tabulator from "../components/edit_tabulator.vue";
	import element from "../services/element.js";
	import workers from "../services/workers.js";
	import store from "../store";

	export default {
		name: "scraping_page",
		components: {
			VueTagsInput,
			FadeLoader: FadeLoader,
			edit_tabulator,
		},
		data() {
			return {
				ready: 0,
				balise: "",
				balises: [
					"h1",
					"h2",
					"h3",
					"h4",
					"h5",
					"h6",
					"article",
					"aside",
					"header",
					"footer",
					"nav",
				],
				tags_balises: [
					{
						text: "h1",
						tiClasses: ["ti-valid"],
					},
					{
						text: "h2",
						tiClasses: ["ti-valid"],
					},
					{
						text: "h3",
						tiClasses: ["ti-valid"],
					},
					{
						text: "h4",
						tiClasses: ["ti-valid"],
					},
					{
						text: "h5",
						tiClasses: ["ti-valid"],
					},
					{
						text: "h6",
						tiClasses: ["ti-valid"],
					},
					{
						text: "article",
						tiClasses: ["ti-valid"],
					},
					{
						text: "aside",
						tiClasses: ["ti-valid"],
					},
					{
						text: "header",
						tiClasses: ["ti-valid"],
					},
					{
						text: "footer",
						tiClasses: ["ti-valid"],
					},
					{
						text: "nav",
						tiClasses: ["ti-valid"],
					},
				],
				parameters: {},
				results: {},
				id: uniqueId(""),
				mapping: {
					columns: [],
					meta: [],
					balises: [],
				},
				mapping_columns: [],
				mapping_meta: [],
				editor: null,
				editor_mapping: null,
				meta: {},
				line_import: null,
				name_template: "",

				screenshot: null,
			};
		},
		props: {
			lvl: {
				default: 1,
			},
		},
		watch: {
			tags_balises: async function () {
				this.balises = [];
				for (var i = 0; i < this.tags_balises.length; i++) {
					if (_.isObject(this.tags_balises[i]))
						this.balises.push(this.tags_balises[i].text);
					else this.balises.push(this.tags_balises[i]);
				}
			},
		},
		methods: {
			async save() {
				if (this.results.screenshot) delete this.results.screenshot;

				var data = {
					parameters: this.parameters,
					mapping: this.mapping,
					results: this.results,
					mapping_columns: this.mapping_columns,
					mapping_meta: this.mapping_meta,
					meta: this.meta,
					balises: this.balises,
				};

				return data;
			},
			async load(data) {
				while (this.ready < 2) {
					await new Promise((resolve) => setTimeout(resolve, 100));
				}
				if (data.parameters) {
					this.parameters = data.parameters;
					this.editor.setValue(data.parameters);
				}
				if (data.mapping) {
					this.mapping = data.mapping;
					this.editor_mapping.setValue(data.mapping);
				}
				if (data.results) this.results = data.results;
				if (data.mapping_columns)
					this.mapping_columns = data.mapping_columns;
				if (data.mapping_meta) this.mapping_meta = data.mapping_meta;
				if (data.meta) this.meta = data.meta;
				if (data.balises) {
					this.balises = data.balises;
					this.tags_balises = [];
					for (var i = 0; i < this.balises.length; i++) {
						this.tags_balises.push({
							text: this.balises[i],
							tiClasses: ["ti-valid"],
						});
					}
				}

				//console.log(JSON.stringify(this.tags_balises))
			},
			async save_template() {
				if (this.name_template) {
					var data = {};

					var mapping = this.mapping;
					mapping.meta = [];

					var parameters = this.parameters;
					parameters.url = "";
					for (var i = 0; i < parameters.text.length; i++) {
						for (var j = 0; j < parameters.text[i].length; j++) {
							if (parameters.text[i][j].type != "xpath")
								parameters.text[i][j].text = "";
						}
					}

					data.mapping = mapping;
					data.parameters = parameters;
					data.balises = this.balises;

					// console.log(data)

					await element.save(
						this.name_template,
						"1",
						data,
						"scraping_page_template"
					);
				}
			},
			async update_from_prev_level(prev_data) {
				this.line_import = clone(prev_data);
			},
			async setTabulator() {
				var data = [];
				var mapping_code = `
            var lines = []
            for (var i = 0; i < data.length; i++)
            {
                data[i].meta = JSON.parse(data[i].meta);
                if (data[i].balises)
                    data[i].balises = JSON.parse(data[i].balises);
                var meta = {};
                for (var j = 0; j < data[i].meta.length; j++)
                {
                    meta[data[i].meta[j].name] = data[i].meta[j].content;
                }
                data[i].results = JSON.parse(data[i].results);
        `;

				if (
					this.results &&
					this.results.results &&
					this.results.results.length > 0
				) {
					var line = {
						url: this.results.url,
					};

					if (this.line_import) {
						line = clone(this.line_import);
					}

					for (var i = 0; i < this.mapping.meta.length; i++) {
						if (
							this.mapping.meta[i].column &&
							this.meta.hasOwnProperty(this.mapping.meta[i].name)
						) {
							line[this.mapping.meta[i].column] = this.meta[
								this.mapping.meta[i].name
							]
								.replace(/<[^>]*>+/g, " ")
								.trim()
								.replace(/( *\n *)+/g, "<br />")
								.replace(/&nbsp;/g, " ")
								.replace(/ +/g, " ");
							mapping_code += `
                if (meta["${this.mapping.meta[i].name}"])
                    data[i]["${this.mapping.meta[i].column}"] = meta["${this.mapping.meta[i].name}"].replace(/<[^>]*>+/g, " ").trim().replace(/( *\\n *)+/g, "<br />").replace(/&nbsp;/g, " ").replace(/ +/g, " ");
                else
                    meta["${this.mapping.meta[i].name}"] = "";
                `;
						}
					}

					for (var i = 0; i < this.results.results.length; i++) {
						if (i == 0) {
							mapping_code += `
                        for (var j = 0; j < data[i].results.length; j++)
                        {
                            try
                            {
                            var line = clone(data[i]);
                    `;
						}
						var _line = clone(line);
						if (this.mapping.url) {
							_line[this.mapping.url] = line.url;
							if (i == 0) {
								mapping_code += `
                        line["${this.mapping.url}"] = line.url;
                        `;
							}
						}
						for (var j = 0; j < this.mapping.columns.length; j++) {
							var str = "";
							if (
								this.mapping.columns[j].column &&
								this.results.results[i].hasOwnProperty(
									this.mapping.columns[j].name
								)
							) {
								str = JSON.stringify(
									this.results.results[i][
										this.mapping.columns[j].name
									]
								);
								if (this.mapping.columns[j].result == "un") {
									str = "";
									if (
										this.results.results[i][
											this.mapping.columns[j].name
										].length > 0
									)
										str =
											this.results.results[i][
												this.mapping.columns[j].name
											][0];
									if (i == 0) {
										mapping_code += `
                                if (line.results[j]["${this.mapping.columns[j].name}"].length > 0)
                                    line["${this.mapping.columns[j].column}"] = line.results[j]["${this.mapping.columns[j].name}"][0].replace(/<[^>]*>+/g, " ").trim().replace(/( *\\n *)+/g, "<br />").replace(/&nbsp;/g, " ").replace(/ +/g, " ")
                                else
                                    line["${this.mapping.columns[j].column}"] = "";
                                `;
									}
								} else if (this.mapping.columns[j].separator) {
									str = "";
									if (i == 0) {
										mapping_code += `
                                line["${this.mapping.columns[j].column}"] = "";
                                for (var k = 0; k < line.results[j]["${this.mapping.columns[j].name}"].length; k++)
                                {`;
									}
									if (this.mapping.columns[j].split) {
										var results =
											this.results.results[i][
												this.mapping.columns[j].name
											];
										if (i == 0) {
											mapping_code += `
                                    var results = line.results[j]["${this.mapping.columns[j].name}"];
                                    `;
										}
									}

									if (i == 0) {
										if (this.mapping.columns[j].split) {
											mapping_code += `
                                        if (typeof results == "object")
                                        {
                                            if (k == 0)
                                                line["${this.mapping.columns[j].column}"] = results[0];
                                            else
                                            {
                                                var new_line = clone(line);
                                                new_line["${this.mapping.columns[j].column}"] = results[k]; 
                                                delete new_line.meta;
                                                delete new_line.results;
                                                lines.splice(i, 0, new_line);
                                            }
                                        }
                                        else
                                            line["${this.mapping.columns[j].column}"] = results;
                                    `;
										} else {
											mapping_code += `
                                        if (k != 0)
                                            line["${this.mapping.columns[j].column}"] += "${this.mapping.columns[j].separator}";
                                        if (typeof line.results[j]["${this.mapping.columns[j].name}"][k] == "object")
                                            line["${this.mapping.columns[j].column}"] += JSON.stringify(line.results[j]["${this.mapping.columns[j].name}"][k]);
                                        else
                                            line["${this.mapping.columns[j].column}"] += line.results[j]["${this.mapping.columns[j].name}"][k].replace(/<[^>]*>+/g, " ").trim().replace(/( *\\n *)+/g, "<br />").replace(/&nbsp;/g, " ").replace(/ +/g, " ");
                                    `;
										}

										mapping_code += `
                                }
                                `;
									}

									for (
										var k = 0;
										k <
										this.results.results[i][
											this.mapping.columns[j].name
										].length;
										k++
									) {
										if (this.mapping.columns[j].split) {
											if (typeof results == "object") {
												if (k == 0) str = results[0];
												else {
													var new_line = clone(_line);
													new_line[
														this.mapping.columns[
															j
														].column
													] = [results[k]];
													data.splice(i, 0, new_line);
												}
											} else str = results;
										} else {
											if (k != 0)
												str +=
													this.mapping.columns[j]
														.separator;
											if (
												typeof this.results.results[i][
													this.mapping.columns[j].name
												][k] == "object"
											)
												str += JSON.stringify(
													this.results.results[i][
														this.mapping.columns[j]
															.name
													][k]
												);
											else
												str +=
													this.results.results[i][
														this.mapping.columns[j]
															.name
													][k];
										}
									}
								} else {
									if (i == 0) {
										mapping_code += `
                                line["${this.mapping.columns[j].column}"] = JSON.stringify(line.results[j]["${this.mapping.columns[j].name}"]);
                                `;
									}
								}
							}
							_line[this.mapping.columns[j].column] = str;
						}
						if (this.mapping.balises) {
							for (
								var j = 0;
								j < this.mapping.balises.length;
								j++
							) {
								var str = "";
								if (
									this.mapping.balises[j].column &&
									this.results.balises[i].hasOwnProperty(
										this.mapping.balises[j].name
									)
								) {
									str = JSON.stringify(
										this.results.balises[i][
											this.mapping.balises[j].name
										]
									);
									if (this.mapping.balises[j].index != "") {
										str = "";
										if (
											this.results.balises[i][
												this.mapping.balises[j].name
											].length >
											this.mapping.balises[j].index - 1
										)
											str =
												this.results.balises[i][
													this.mapping.balises[j].name
												][
													this.mapping.balises[j]
														.index - 1
												];
										if (i == 0) {
											mapping_code += `
                                    if (line.balises[j]["${
										this.mapping.balises[j].name
									}"].length > ${
												this.mapping.balises[j].index -
												1
											})
                                        line["${
											this.mapping.balises[j].column
										}"] = line.balises[j]["${
												this.mapping.balises[j].name
											}"][${
												this.mapping.balises[j].index -
												1
											}].replace(/<[^>]*>+/g, " ").trim().replace(/( *\\n *)+/g, "<br />").replace(/&nbsp;/g, " ").replace(/ +/g, " ")
                                    else
                                        line["${
											this.mapping.balises[j].column
										}"] = "";
                                    `;
										}
									} else if (
										this.mapping.balises[j].separator
									) {
										str = "";
										if (i == 0) {
											mapping_code += `
                                    line["${this.mapping.balises[j].column}"] = "";
                                    for (var k = 0; k < line.balises[j]["${this.mapping.balises[j].name}"].length; k++)
                                    {
                                        if (k != 0)
                                            line["${this.mapping.balises[j].column}"] += "${this.mapping.balises[j].separator}";
                                        line["${this.mapping.balises[j].column}"] += line.balises[j]["${this.mapping.balises[j].name}"][k].replace(/<[^>]*>+/g, " ").trim().replace(/( *\\n *)+/g, "<br />").replace(/&nbsp;/g, " ").replace(/ +/g, " ");
                                    }    `;
										}
										for (
											var k = 0;
											k <
											this.results.balises[i][
												this.mapping.balises[j].name
											].length;
											k++
										) {
											if (k != 0)
												str +=
													this.mapping.balises[j]
														.separator;
											str +=
												this.results.balises[i][
													this.mapping.balises[j].name
												][k];
										}
									} else {
										if (i == 0) {
											mapping_code += `
                                    line["${this.mapping.balises[j].column}"] = JSON.stringify(line.balises[j]["${this.mapping.balises[j].name}"]);
                                    `;
										}
									}
								}
								_line[this.mapping.balises[j].column] = str;
							}
						}
						data.push(_line);
						if (i == 0) {
							mapping_code += `
                            delete line.meta;
                            delete line.results;
                            if (line.balises)
                            delete line.balises;
                            lines.push(line);
                        }
                        catch (err)
                        {
                            console.error(err)
                        }
                    }
                    `;
						}
					}
				}

				mapping_code += `
          }
          data = lines;
        `;

				this.$refs.edit_tabulator.set_data(data);
				this.$emit("update_data", this.lvl, data);
				this.$emit("update_mapping", this.lvl, mapping_code);
			},
			async start() {
				var params = this.parameters;
				params.balises = this.balises;

				var data = {
					action: "scraping",
					parameters: params,
				};

				this.results = "En cours de traitement";
				this.results = await workers.test(data);

				this.results = this.results.data.json[0];

				if (this.results.screenshot)
					this.screenshot = this.results.screenshot;
				else this.screenshot = null;

				var action = [
					{
						name: "action_delete",
						delete: ["//script", "//style"],
					},
				];

				if (this.parameters.sleep) {
					action.push({
						name: "action_sleep",
						sleep: this.parameters.sleep,
					});
				}

				action.push(this.results.params);

				if (this.results.page && this.results.page.length > 0) {
					action.push({
						name: "action_custom",
						code: "if (line.page) { line.url = line.page } else { line.page = '' }",
					});
					action.push({
						name: "action_goto",
						column_values: "page",
					});
					action = {
						actions: {
							name: "loop",
							actions: action,
							max: this.parameters.page.max
								? this.parameters.page.max
								: 1,
							conditions_to_continue: [
								{
									name: "different",
									value: "^$",
									column: "page",
								},
							],
							column_action: "_results",
						},
						code: "var lines = [];\n\nfor (var i = 0; i < line.length; i++)\n{\n    for (var j = 0; j < line[i]._results.length; j++)\n    {\n        var l = Object.assign({}, line[i], line[i]._results[j]);\n        delete l._results;\n        lines.push(l);\n    }\n}\n\nline = lines;",
					};
				} else action = { actions: action };

				if (this.lvl == 1) action.url = this.parameters.url;

				console.log(action);

				this.$emit("update_xpath", this.lvl, action);

				// console.log(this.results)

				this.results.params = JSON.stringify(
					this.results.params,
					null,
					2
				);
				try {
					this.results.results_string = JSON.stringify(
						this.results.results,
						null,
						2
					);
				} catch (err) {}

				this.results.meta_string = JSON.stringify(
					this.results.meta,
					null,
					2
				);
				this.results.balises_string = JSON.stringify(
					this.results.balises,
					null,
					2
				);
				this.results.details = JSON.stringify(
					this.results.details,
					null,
					2
				);

				this.meta = {};

				for (var i = 0; i < this.results.meta.length; i++) {
					this.meta[this.results.meta[i].name] =
						this.results.meta[i].content;
					/*if (!this.mapping_meta.includes(this.results.meta[i].name))
        {
          this.mapping.meta.push({
            name: this.results.meta[i].name,
            column: "",
            value: this.results.meta[i].content
          });
          this.mapping_meta.push(this.results.meta[i].name);
        }
        else
        {
          for (var j = 0; j < this.mapping.meta.length; j++)
          {
            if (this.mapping.meta[j].name == this.results.meta[i].name)
              this.mapping.meta[j].value = this.results.meta[i].content;
          }
        }*/
				}

				for (var i = 0; i < this.results.results.length; i++) {
					var keys = Object.keys(this.results.results[i]);
					for (var j = 0; j < keys.length; j++) {
						if (i == 0) {
							if (!this.mapping_columns.includes(keys[j])) {
								this.mapping.columns.push({
									name: keys[j],
									column: keys[j],
									result: "plusieurs",
									separator: " | ",
								});
								this.mapping_columns.push(keys[j]);
							}
						}
						for (
							var k = 0;
							k < this.results.results[i][keys[j]].length;
							k++
						) {
							this.results.results[i][keys[j]][k] =
								this.results.results[i][keys[j]][k]
									.replace(/<[^>]*>+/g, " ")
									.trim()
									.replace(/( *\n *)+/g, "<br />")
									.replace(/&nbsp;/g, " ")
									.replace(/ +/g, " ");
						}
					}
				}

				for (var i = 0; i < this.results.balises.length; i++) {
					var keys = Object.keys(this.results.balises[i]);
					for (var j = 0; j < keys.length; j++) {
						for (
							var k = 0;
							k < this.results.balises[i][keys[j]].length;
							k++
						) {
							this.results.balises[i][keys[j]][k] =
								this.results.balises[i][keys[j]][k]
									.replace(/<[^>]*>+/g, " ")
									.trim()
									.replace(/( *\n *)+/g, "<br />")
									.replace(/&nbsp;/g, " ")
									.replace(/ +/g, " ");
						}
					}
					// console.log(this.results.balises)
				}

				this.editor_mapping.setValue(this.mapping);

				/*this.result_stars_content = [];
      for (var i = 0; i < this.results.result_stars_content.length; i++)
      {
        this.result_stars_content.push(this.results.result_stars_content[i]
          .replace(/<[^>]*>+/g, " ")
          .replace(/( *\n *)+/g, "<br />")
          .replace(/ +/g, " "))
      }*/
			},
			async set_url(data) {
				this.line_import = clone(data);

				while (this.ready < 2) {
					await new Promise((resolve) => setTimeout(resolve, 100));
				}
				this.parameters.url = data.url;
				this.editor.setValue(this.parameters);
			},
			add_meta(meta) {
				this.mapping.meta.push(meta);
				this.editor_mapping.setValue(this.mapping);
			},
			add_balise(balise) {
				this.mapping.balises.push(balise);
				this.editor_mapping.setValue(this.mapping);
			},
		},
		mounted: async function () {
			var self = this;

			if (store.state.user.rules && !store.state.user.rules.scraping) {
				this.$router.push({ name: "profile" });
			}

			var schema = {
				title: "paramètres",
				type: "object",
				required: [
					"url",
					"text",
					"meta",
					"type",
					"sleep",
					"screenshot",
				],
				anyOf: [
					{
						title: "paramètres",
						properties: {
							balises: {
								options: { hidden: true },
							},
							type: {
								type: "string",
								title: "type",
								enum: ["paramètres"],
								options: { hidden: true },
							},
							url: {
								type: "string",
								title: "Url",
							},
							text: {
								type: "array",
								format: "table",
								title: "Groupes",
								items: {
									type: "array",
									format: "table",
									title: "Groupe",
									default: [{}],
									items: {
										type: "object",
										title: "Recherche",
										properties: {
											name: {
												type: "string",
												title: "Nom",
											},
											text: {
												type: "string",
												title: "Recherche",
											},
											search: {
												type: "string",
												title: "Où rechercher",
												enum: [
													"contient",
													"égal",
													"au début",
												],
											},
											type: {
												type: "string",
												title: "Type de recherche",
												enum: [
													"texte",
													"url",
													"url externe",
													"image",
													"xpath",
												],
											},
											delimiter: {
												type: "boolean",
												format: "checkbox",
												title: "Délimiteur",
												default: true,
												options: { hidden: true },
											},
											one_result: {
												type: "boolean",
												format: "checkbox",
												title: "Un résultat",
												default: true,
												options: { hidden: true },
											},
											no_transform: {
												type: "boolean",
												format: "checkbox",
												title: "Garder xpath",
												default: false,
												options: { hidden: true },
											},
										},
									},
								},
							},
							parent: {
								type: "string",
								title: "Xpath parent",
							},
							page: {
								title: "Page suivante",
								type: "object",
								required: ["url", "max"],
								properties: {
									url: {
										type: "string",
										title: "Url de la page suivante",
									},
									max: {
										type: "string",
										title: "Maximum de pages",
									},
								},
							},
							sleep: {
								type: "integer",
								title: "Temps d'attente",
							},
							screenshot: {
								type: "string",
								title: "Capture d'écran",
								enum: ["non", "haut de page", "toute la page"],
							},
							meta: {
								type: "boolean",
								format: "checkbox",
								title: "Récupérer les balises métadonnées",
								options: { hidden: true },
								default: true,
							},
						},
					},
					{
						title: "paramètres étendus",
						properties: {
							balises: {
								options: { hidden: true },
							},
							type: {
								type: "string",
								title: "type",
								enum: ["paramètres étendus"],
								options: { hidden: true },
							},
							url: {
								type: "string",
								title: "Url",
							},
							text: {
								type: "array",
								format: "table",
								title: "Groupes",
								items: {
									type: "array",
									format: "table",
									title: "Groupe",
									default: [{}],
									items: {
										type: "object",
										title: "Recherche",
										properties: {
											name: {
												type: "string",
												title: "Nom",
											},
											text: {
												type: "string",
												title: "Recherche",
											},
											search: {
												type: "string",
												title: "Où rechercher",
												enum: [
													"contient",
													"égal",
													"au début",
												],
											},
											type: {
												type: "string",
												title: "Type de recherche",
												enum: [
													"texte",
													"url",
													"url externe",
													"image",
													"xpath",
												],
											},
											delimiter: {
												type: "boolean",
												format: "checkbox",
												title: "Délimiteur",
												default: true,
											},
											one_result: {
												type: "boolean",
												format: "checkbox",
												title: "Un résultat",
												default: true,
											},
											no_transform: {
												type: "boolean",
												format: "checkbox",
												title: "Garder xpath",
												default: false,
											},
										},
									},
								},
							},
							parent: {
								type: "string",
								title: "Xpath parent",
							},
							page: {
								title: "Page suivante",
								type: "object",
								required: ["url", "max"],
								properties: {
									url: {
										type: "string",
										title: "Url de la page suivante",
									},
									max: {
										type: "string",
										title: "Maximum de pages",
									},
								},
							},
							sleep: {
								type: "integer",
								title: "Temps d'attente",
							},
							screenshot: {
								type: "string",
								title: "Capture d'écran",
								enum: ["non", "haut de page", "toute la page"],
							},
							meta: {
								type: "boolean",
								format: "checkbox",
								title: "Récupérer les balises métadonnées",
								options: { hidden: true },
								default: true,
							},
						},
					},
				],
			};

			const element = document.getElementById("jsoneditor-" + this.id);

			this.editor = new JSONEditor(element, {
				schema: schema,
				keep_oneof_values: true,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				object_background: "",
				prompt_before_delete: false,
				display_required_only: true,
				disable_array_reorder: true,
			});

			await new Promise((resolve, reject) => {
				self.editor.on("ready", function () {
					self.ready++;
					if (resolve) resolve();
				});
			});

			this.editor.on("change", function () {
				self.parameters = self.editor.getValue();

				var is_modify = false;
				for (var i = 0; i < self.parameters.text.length; i++) {
					if (self.parameters.text[i].length == 0) {
						is_modify = true;
						self.parameters.text.splice(i, 1);
						i--;
					}
				}
				if (is_modify) self.editor.setValue(self.parameters);
			});

			var schema_mapping = {
				title: "Mapping",
				type: "object",
				properties: {
					url: {
						type: "string",
						title: "Url",
						default: "url",
					},
					columns: {
						type: "array",
						format: "table",
						title: "Colonnes",
						options: {
							disable_array_add: true,
						},
						items: {
							type: "object",
							title: "Colonne",
							properties: {
								name: {
									type: "string",
									title: "Colonne scraping",
								},
								column: {
									type: "string",
									title: "Colonne résultat",
								},
								result: {
									type: "string",
									title: "Résultat",
									enum: ["un", "plusieurs"],
									options: { hidden: true },
									default: "plusieurs",
								},
								separator: {
									type: "string",
									title: "Séparateur",
									default: " | ",
								},
								split: {
									type: "boolean",
									title: "Split",
									type: "checkbox",
								},
							},
						},
					},
					meta: {
						type: "array",
						format: "table",
						title: "Metadonnées",
						options: {
							disable_array_add: true,
						},
						items: {
							type: "object",
							title: "Colonne",
							properties: {
								name: {
									type: "string",
									title: "Colonne scraping",
								},
								column: {
									type: "string",
									title: "Colonne résultat",
								},
								value: {
									type: "string",
									title: "Valeur récupérée",
									readonly: true,
									options: { hidden: true },
								},
							},
						},
					},
					balises: {
						type: "array",
						format: "table",
						title: "Balises",
						options: {
							disable_array_add: false,
						},
						items: {
							type: "object",
							title: "Colonne",
							properties: {
								name: {
									type: "string",
									title: "Nom",
								},
								column: {
									type: "string",
									title: "Colonne résultat",
								},
								index: {
									type: "string",
									title: "Index",
								},
								separator: {
									type: "string",
									title: "Séparateur",
								},
							},
						},
					},
				},
			};

			const element_mapping = document.getElementById(
				"jsoneditor-mapping-" + this.id
			);

			this.editor_mapping = new JSONEditor(element_mapping, {
				schema: schema_mapping,
				keep_oneof_values: false,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				object_background: "",
				prompt_before_delete: false,
				display_required_only: false,
				disable_array_reorder: true,
				disable_array_delete_all_rows: true,
				disable_array_delete_last_row: true,
				disable_array_reorder: true,
			});

			await new Promise((resolve, reject) => {
				self.editor_mapping.on("ready", function () {
					self.ready++;
					if (resolve) resolve();
				});
			});

			this.editor_mapping.on("change", function () {
				self.mapping = self.editor_mapping.getValue();
				self.setTabulator();
			});
		},
	};
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
		margin-top: 30px;
	}
</style>
